import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowRight } from "lucide-react";
import { PRODUCTS } from "@/data/products";
import { Reveal } from "@/components/Reveal";

export default function ProductsIndex() {
  return (
    <>
      <Helmet>
        <title>Spring Products | Compression, Extension, Torsion, Elevator Buffers, Die Springs & Wireforms | MESCO</title>
        <meta name="description" content="Custom spring manufacturer: compression springs 0.1–40mm, extension springs, torsion springs, elevator buffer springs, die springs, wireforms & assemblies. All materials incl exotic alloys. Mumbai India." />
      </Helmet>
      <div className="pt-40 pb-16 border-b border-[#334772]/15 blueprint-grid" data-testid="products-index-hero">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <p className="font-mono-spec text-[11px] tracking-[0.35em] uppercase text-[#334772]">[ PRODUCT RANGE ]</p>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl uppercase leading-[0.9] text-[#334772] mt-6">
              One roof.<br />Every spring.
            </h1>
            <p className="mt-6 max-w-2xl text-[#706F70] leading-relaxed">
              From 0.1 mm instrument wire to 40 mm hot-wound heavy sections — every major spring type, engineered,
              tested and certified in our Mumbai works.
            </p>
          </Reveal>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 gap-6">
        {PRODUCTS.map((p, i) => (
          <Reveal key={p.slug} delay={(i % 2) * 0.1}>
            <Link
              to={`/products/${p.slug}`}
              data-testid={`product-index-card-${p.slug}`}
              className="group relative block h-80 overflow-hidden border border-[#334772]/15 hover:border-[#334772] transition-colors duration-300"
            >
              <img src={p.image} alt={p.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover grayscale contrast-125 group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
              <div className="absolute bottom-0 inset-x-0 p-7">
                <span className="font-mono-spec text-[10px] tracking-[0.25em] uppercase text-white">{String(i + 1).padStart(2, "0")} / PRODUCT</span>
                <h2 className="font-display text-3xl text-white uppercase tracking-wide mt-1">{p.nav}</h2>
                <p className="mt-2 text-sm text-[#DDE3EE]">{p.tagline}</p>
                <span className="mt-3 inline-flex items-center gap-2 font-mono-spec text-[10px] tracking-[0.2em] uppercase text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  View range <ArrowRight className="w-3 h-3 text-[#334772]" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </>
  );
}
